import React from 'react'
import get from 'lodash/get'
import Grid from '@material-ui/core/Grid'
import Box from '@material-ui/core/Box'
import TextField from '@material-ui/core/TextField'
import { useFormContext } from 'react-hook-form'
import CoachCardSm from 'components/coach-card-small'
import {
  InputWrapper,
  Header,
  HelperText,
  QuestionText,
  NextButton,
} from '../styles'
import { useWizardFormContext } from 'components/wizard-form/context'
import ReCAPTCHA from 'react-google-recaptcha'
import { RECAPTCHA_V2_KEY } from 'env'
import FormHelperText from '@material-ui/core/FormHelperText'
import FormControl from '@material-ui/core/FormControl'
import { Questionnaire } from '../constants'

const contactSectionConfig = [
  {
    name: 'firstName',
    label: 'First Name',
    type: 'text',
  },
  {
    name: 'lastName',
    label: 'Last Name',
    type: 'text',
  },
  {
    name: 'phoneNumber',
    label: 'Phone Number',
    type: 'text',
  },
  {
    name: 'email',
    label: 'Email',
    type: 'text',
  },
]

const childContactSectionConfig = [
  {
    name: 'childFirstName',
    label: 'First Name',
    type: 'text',
  },
  {
    name: 'childLastName',
    label: 'Last Name',
    type: 'text',
  },
]

export const ContactInfo = ({
  coach,
  recaptchaToken,
  setRecaptchaToken,
  leadCreateError,
}) => {
  const { register, errors } = useFormContext()
  const { formValues, advance } = useWizardFormContext()
  const hasChild = get(formValues, 'questionnaire[0].answer') === 'my child'
  const currentStep = 1
  const nextStep = 2

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md={8}>
        <Header variant="h4">Coaching Request</Header>
        <HelperText variant="body1">
          These questions will help the coach to find out more about you and the
          way you golf.
        </HelperText>
      </Grid>
      <Grid item xs={12} md={4} style={{ marginLeft: 'auto' }}>
        <CoachCardSm coach={coach} />
      </Grid>
      <Grid container item>
        <Grid item md={6} xs={12}>
          <QuestionText variant="h6">
            {Questionnaire.CONTACT_DETAILS.question}
          </QuestionText>
          <Box my={2}>
            {contactSectionConfig.map(({ name, label, type }) => (
              <InputWrapper key={name}>
                <TextField
                  key={name}
                  name={name}
                  label={label}
                  type={type}
                  inputRef={register()}
                  variant="outlined"
                  className={`text-input ${errors[name] && ' error'}`}
                  error={!!errors[name]}
                  helperText={errors[name]?.message}
                  style={{
                    background: '#fff',
                  }}
                />
              </InputWrapper>
            ))}
          </Box>
          {hasChild ? (
            <>
              <QuestionText variant="h6">
                What is your child’s information?
              </QuestionText>
              <Box my={2}>
                {childContactSectionConfig.map(({ name, label, type }, i) => (
                  <InputWrapper key={name}>
                    <TextField
                      key={name}
                      name={`questionnaire[${i + 1}].answer`}
                      label={label}
                      type={type}
                      inputRef={register()}
                      variant="outlined"
                      className={`text-input ${errors[name] && ' error'}`}
                      error={!!errors[name]}
                      helperText={errors[name]?.message}
                      style={{
                        background: '#fff',
                      }}
                    />
                  </InputWrapper>
                ))}
              </Box>
            </>
          ) : null}
          <FormControl margin="normal">
            <ReCAPTCHA
              sitekey={RECAPTCHA_V2_KEY}
              onChange={token => setRecaptchaToken(token)}
              onExpired={() => setRecaptchaToken('expired')}
            />
            {leadCreateError && (
              <FormHelperText error>
                An error has occurred. Please try again later.
              </FormHelperText>
            )}
            {errors.recaptchaToken && (
              <FormHelperText error>Fill in reCAPTCHA</FormHelperText>
            )}
          </FormControl>
          <input
            type="hidden"
            ref={register()}
            name="recaptchaToken"
            value={recaptchaToken}
          />
          <input
            type="hidden"
            ref={register()}
            name={`questionnaire[${currentStep}].question`}
            value="What is your child first name?"
          />
          <input
            type="hidden"
            ref={register()}
            name={`questionnaire[${nextStep}].question`}
            value="What is your child last name?"
          />
          <NextButton variant="contained" color="primary" onClick={advance}>
            Next
          </NextButton>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default ContactInfo
